import { useState } from "preact/hooks";
import { useTranslation } from "react-i18next";
import { BetAvatar, Box } from "../../shared/ui";
import { Navigation } from "../Navigation";
import styles from "./AvatarSelector.module.scss";

export interface AvatarSelectorProps {
  currentAvatar?: string;
  username?: string;
  onAvatarSelect?: (_avatar: string) => void;
  onBack?: () => void;
}

const AVATARS = [
  "Avatar_2",
  "Avatar_3",
  "Avatar_4",
  "Avatar_5",
  "Avatar_6",
  "Avatar_7",
  "Avatar_8",
  "Avatar_9",
  "Avatar_10",
  "Avatar_11",
  "Avatar_12",
  "Avatar_13",
  "Avatar_14",
  "Avatar_15",
  "Avatar_16",
  "Avatar_17",
  "Avatar_18",
  "Avatar_19",
  "Avatar_20",
  "Avatar_21",
  "Avatar_22",
  "Avatar_23",
  "Avatar_24",
  "Avatar_25",
  "Avatar_26",
  "Avatar_27",
  "Avatar_28",
];

export function AvatarSelector({
  currentAvatar,
  username,
  onAvatarSelect,
}: AvatarSelectorProps) {
  const [selectedAvatar, setSelectedAvatar] = useState(
    currentAvatar ?? "Avatar_1"
  );
  const { t } = useTranslation();
  const handleAvatarClick = (avatar: string) => {
    setSelectedAvatar(avatar);
    onAvatarSelect?.(avatar);
  };

  return (
    <div className={styles.container}>
      <Navigation title={t("auth.change_avatar").toUpperCase()} />
      <div className={styles.currentAvatarSection}>
        <div className={styles.currentAvatarContainer}>
          <BetAvatar avatar={`${selectedAvatar}.png`} size={76} />
        </div>
        <p className={styles.username}>{username}</p>
      </div>

      <Box bg="black" className={styles.avatarGrid}>
        {AVATARS.map((avatar) => (
          <button
            key={avatar}
            className={`${styles.avatarOption} ${
              selectedAvatar === avatar ? styles.selected : ""
            }`}
            onClick={() => handleAvatarClick(avatar)}
          >
            <BetAvatar
              avatar={`${avatar}.png`}
              className={styles.avatarImage}
              size={42}
            />
          </button>
        ))}
      </Box>
    </div>
  );
}
